import {
  Paragraph,
  SizableText,
  SmartLink,
  Stack,
  YStack,
  YStackProps,
  shadowStandard,
} from '@my/ui'
import { ArticleCategoryTag } from 'app/features/blog/components'
import { SolitoImage } from 'solito/image'

export interface ArticleCardProps {
  id: string
  title: string
  shortDescription: string
  featuredImage: {
    url: string
    alt: string
  }
  primaryCategory: {
    name: string
    slug: string
  }
  slug: string
  wrapperStyle?: YStackProps
  imagePriority?: boolean
}

const interactionStyles = {
  hoverStyle: {
    opacity: 0.8,
  },
  pressStyle: {
    opacity: 0.75,
  },
  focusStyle: {
    opacity: 0.7,
  },
}

export const ArticleCard = (props: ArticleCardProps) => {
  const href = `/life/${props.slug}`

  return (
    <YStack className="ArticleCard" br="$3" bg="$white" {...shadowStandard} {...props.wrapperStyle}>
      {props.featuredImage && (
        <SmartLink
          Component={Stack}
          aria-label='View article'
          tabIndex={-1}
          href={href}
          btlr="$3"
          btrr="$3"
          overflow="hidden"
          aspectRatio={16 / 9}
          {...interactionStyles}
        >
          <SolitoImage
            src={props.featuredImage.url}
            alt={props.featuredImage.alt || props.title}
            fill
            contentFit="cover"
            sizes="(max-width: 460px) 100vw, (max-width: 768px) 50vw, 300px"
            priority={props.imagePriority}
          />
        </SmartLink>
      )}

      <YStack p="$3.5" gap="$2.5" flex={1}>
        <SmartLink href={href} Component={YStack} gap="$2.5" {...interactionStyles}>
          <SizableText
            tag="h3"
            numberOfLines={3}
            size="$5"
            fow="700"
            $gtSm={{ size: '$6', fow: '700' }}
          >
            {props.title}
          </SizableText>
          {props.shortDescription && (
            <Paragraph numberOfLines={2} size="$2" color="$gray11" fow="500">
              {props.shortDescription}
            </Paragraph>
          )}
        </SmartLink>
        {props.primaryCategory?.name && (
          <ArticleCategoryTag
            name={props.primaryCategory.name}
            href={`/life/${props.primaryCategory.slug}`}
            alignSelf="flex-start"
            mt='auto'
          />
        )}
      </YStack>
    </YStack>
  )
}
